import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import Fa from 'react-fontawesome';

function TVFieldNameRenderer(props) {
  const tvField = props.data;
  let description = null;

  if (tvField.definition && tvField.definition.length > 0) {
    const tip = (
      <Tooltip id={`data-tv-tip-${tvField.id}`}>
        <div>{tvField.definition}</div>
      </Tooltip>
    );
    description = (
      <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={tip}>
        <Fa name="info-circle" className="text-active" />
      </OverlayTrigger>
    );
  }

  const activeTip = (
    <Tooltip id={`data-tv-active-tip-${tvField.id}`}>
      <div>{tvField.active ? 'Active' : 'Inactive'}</div>
    </Tooltip>
  );
  const star = (
    <OverlayTrigger key="star" trigger={['hover', 'focus']} placement="right" overlay={activeTip}>
      <Fa name="star" className={tvField.active ? 'text-warning' : 'text-muted'} />
    </OverlayTrigger>
  );

  return (
    <div style={{ paddingLeft: '10px' }}>
      {star} <code>{tvField.name}</code> {description}
    </div>
  );
}

TVFieldNameRenderer.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    tv_field: PropTypes.shape({}),
    definition: PropTypes.string,
    name: PropTypes.string,
    active: PropTypes.bool,
  }).isRequired,
}
TVFieldNameRenderer.defaultProps = {
}

export default TVFieldNameRenderer;
